export const BOXES_IDS_COLLECTION = [
    '4695', '4744', '4331', '4371', '4875', '4982', '4444', '5050', '4443', '5433', '5505',
];

export const BOXES_WITHOUT_DETAILS_COMPOSITION = [
    '4331', '4875', '5050', '4695', '5505', '5545',
];

export const dishesWithDetailsMap = {
    4331: 'romantic',
    4875: 'march',
    4443: 'easterbox',
    5050: 'wednesday',
    4695: 'halloween',
    4371: 'maslenitsa',
    5505: 'school',
    5545: 'harry',
};

// в resolveOverrideImage можно добавить изображение с клиента для царь-карточки
